module.exports = __webpack_public_path__ + "static/media/favicon.06b71595.png";